import { UseCaseInteractor } from '../../../kernel/use-case'
import { RolePermissions } from '../domain/role'
import { RoleRepository } from '../domain/role.repository'

export const getRolePermissionsUseCase: UseCaseInteractor<
  [roleRepository: RoleRepository],
  [roleId: string],
  RolePermissions
> =
  (roleRepository: RoleRepository) =>
  async (roleId: string): Promise<RolePermissions> => {
    return roleRepository.getRolePermissions(roleId)
  }
